export const DEFAUNT_INTERVAL = 10000